import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import NavLink from 'react-router-dom/NavLink';


import { getIsDrawRequestsExist } from 'selectors';

import { CheckApplicationsForExistence, WithUser } from 'hocs';
import { getPath } from 'utils';
import { isActive, INDEX_PATH, DRAW_REQUESTS_PATH, PROFILE_PATH, MY_APPLICATIONS_PATH } from 'constants/routes';
import { Icon } from 'components/shared';

import logo from 'components/shared/LogoImage/logo-white.png';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    contact: PropTypes.shape({}),
  }),
  isDrawRequestsExist: PropTypes.bool.isRequired,
};

const defaultProps = {
  user: null,
};

function UserNavigation(props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDrawRequestsExist, user } = props;
  return (
    <>
      <MenuBurger onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <Icon icon="close" width='1.5' /> : <Icon icon="menuBurger" width='1.5' />}</MenuBurger>
      <Container isMenuOpen={isMenuOpen}>
        <Logo>
          <MenuLink exact to={INDEX_PATH}>
            <LogoImg src={logo} />
          </MenuLink>
        </Logo>
        <Item>
          <MenuLink exact to={INDEX_PATH}>
            <MenuText>Home</MenuText>
          </MenuLink>
        </Item>
        {user && (
          <Item>
            <MenuLink
              isActive={isActive('applications')}
              to={getPath(MY_APPLICATIONS_PATH, { id: user.id, status: 'active' })}
            >
              <MenuText>Applications</MenuText>
            </MenuLink>
          </Item>
        )}
        {user && isDrawRequestsExist && (
          <Item>
            <MenuLink to={DRAW_REQUESTS_PATH}>
              <MenuText>Draw Requests</MenuText>
            </MenuLink>
          </Item>
        )}

        {user && (
          <Item>
            <MenuLink to={getPath(PROFILE_PATH, { id: user.id })}>
              <MenuText>Profile</MenuText>
            </MenuLink>
          </Item>
        )}
      </Container>
    </>
  );
}

const Container = styled.ul`
  display: flex;
  align-items: center;
  @media (max-width: 1200px) {
    display: ${({ isMenuOpen }) => (isMenuOpen ? 'flex' : 'none')};
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    top: 58px;
    left: 0;
    color: var(--color-primary);
    width: 100vw;
    background-color: #fff;
    z-index: 10;
    button {
      width: 100%;
      margin: 0;
      padding: 20px 0;
      text-align: center;
      flex: 1 0 au
    }   
  }
`;
const MenuBurger = styled.div`
  display: none;
  color: #fff;
  cursor: pointer;
  @media (max-width: 1200px) {
    display: flex;
  }
`;

const Item = styled.li`
  display: block;
  margin: 0;
  padding: 0 0.625rem;
  &:first-child {
    padding-left: 0;
  }
  @media (max-width: 1200px) {
    width: 100%;
    padding: 0;
    & + li {
    padding-left: 0;
  }
`;

const MenuLink = styled(NavLink).attrs({})`
  position: relative;
  display: block;
  outline: 0;
  text-decoration: none;
  line-height: 12px;
  font-size: var(--font-size-xs);
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  transition: color cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
  &:hover {
    color: var(--color-secondary-hover);
    text-decoration: none;
  }
  &.active {
    color: var(--color-secondary-hover);
    &:before {
      position: absolute;
      bottom: -5px;
      content: '';
      width: 100%;
      height: 2px;
      background: var(--color-secondary-hover);
    }
  }
  @media (max-width: 1200px) {
    color: #1E1E1E;
    font-size: 14px;
    line-height: 19px;
    font-weight: 700;
    padding: 18px 24px 18px 24px;
    border-bottom: 1px solid #E7DAC5;
    margin-bottom: 0;
    &:hover {
    color: var(--color-secondary);
    }
    &.active {
      color:  var(--color-secondary);
      &:before {
        position: absolute;
        content: '';
        width: 100%;
        background: transparent;
      }
    }
  }
`;

const MenuText = styled.span`
  display: block;
  line-height: 35px;
  width: max-content;
`;

const Logo = styled.div`
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  margin-right: 20px;
`;

const LogoImg = styled.img`
  width: 100%;
  max-width: 6.6875rem;
  vertical-align: middle;
`;

UserNavigation.propTypes = propTypes;
UserNavigation.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  isDrawRequestsExist: getIsDrawRequestsExist(state),
});

const enhance = compose(WithUser, CheckApplicationsForExistence, connect(mapStateToProps), pure);

export default enhance(UserNavigation);
